export enum JobStatus {
	Pending = 'pending',
	InProgress = 'inProgress',
	Completed = 'completed',
	Failed = 'failed'
}
